import ComputePipeline from "../../lib/services/compute/computepipeline";
import { YuvFormat } from "../../lib/services/compute/yuvdefs";

export default class BlackWhiteMaskBPipeline extends ComputePipeline {
  private device: GPUDevice;
  private layout: GPUBindGroupLayout;
  private format: YuvFormat;
  private info_buffer: GPUBuffer | null = null;
  private bwgrid_buffer: GPUBuffer | null = null;

  constructor(key: string, shader: GPUShaderModule, device: GPUDevice, threads: number, format: YuvFormat) {
    super(key,threads);
    this.device = device;
    this.format = format;

    const V = GPUShaderStage.COMPUTE;
    const tex = { sampleType: "unfilterable-float" as const, viewDimension: "2d" as const, multisampled: false };
    const stex_r = { access: "read-only" as const, format: "rgba8unorm" as const };
    const stex_w = { access: "write-only" as const, format: "rgba8unorm" as const };

    const entries: GPUBindGroupLayoutEntry[] = format === "NV12"
      ? [
         { binding: 0, visibility: V, buffer: { type: "storage" } },
          { binding: 1, visibility: V, buffer: { type: "storage" } },
          { binding: 2, visibility: V, texture: tex },
          { binding: 3, visibility: V, texture: tex },
          { binding: 4, visibility: V, storageTexture: stex_r },
          { binding: 5, visibility: V, storageTexture: stex_w },
        ]
      : [
          { binding: 0, visibility: V, buffer: { type: "storage" } },
          { binding: 1, visibility: V, buffer: { type: "storage" } },
          { binding: 2, visibility: V, texture: tex },
          { binding: 3, visibility: V, texture: tex },
          { binding: 4, visibility: V, texture: tex },
          { binding: 5, visibility: V, storageTexture: stex_r },
          { binding: 6, visibility: V, storageTexture: stex_w },
        ];

    this.layout = device.createBindGroupLayout({ entries });
    this.pipeline = device.createComputePipeline({
      layout: device.createPipelineLayout({ bindGroupLayouts: [this.layout] }),
      compute: { module: shader, entryPoint: key },
    });
  }

  build(info_buffer: GPUBuffer, bwgrid_buffer: GPUBuffer): void {
    this.info_buffer = info_buffer;
    this.bwgrid_buffer = bwgrid_buffer;
   
  }

  rebuild(
    y_view: GPUTextureView,
    cbcr_or_cb_view: GPUTextureView,
    mask_tex_view: GPUTextureView,
    mask_tex_read_view: GPUTextureView,
    cr_view?: GPUTextureView
  ): void {
    const entries: GPUBindGroupEntry[] = [
      { binding: 0, resource: { buffer: this.info_buffer! } },
      { binding: 1, resource: { buffer: this.bwgrid_buffer! } },
      { binding: 2, resource: y_view },
      { binding: 3, resource: cbcr_or_cb_view },
    ];

    if (this.format === "NV12") {
      entries.push({ binding: 4, resource: mask_tex_read_view });
      entries.push({ binding: 5, resource: mask_tex_view });
    } else {
      entries.push({ binding: 4, resource: cr_view! });
      entries.push({ binding: 5, resource: mask_tex_read_view });
      entries.push({ binding: 6, resource: mask_tex_view });
    }

    this.bindgroup = this.device.createBindGroup({ layout: this.layout, entries });
  }
}